import { useTranslation } from 'react-i18next';
import { formatSiteDateTime } from '@d-orca/shared/client/utils';
import type { IChecklistItemCompletion } from '@interfaces/IScheduler';
import { EvidencePhoto } from './EvidencePhoto';
import styles from './ChecklistCard.module.css';

/** What a completed check was proved with: the photo, the comment, the 黒板,
 *  and who ticked it when (in the site's zone, once it is known). */
export function ChecklistEvidence({ completion, tz }: { completion: IChecklistItemCompletion; tz: string | undefined }) {
  const { t, i18n } = useTranslation();
  const { attachedPhoto, comment, blackboard, checkedByName, checkedAt } = completion;
  const board = [blackboard?.workType, blackboard?.location, blackboard?.date].filter(Boolean).join(' · ');
  const when = checkedAt && tz ? formatSiteDateTime(checkedAt, tz, i18n.language) : '';
  return (
    <div className={`${styles.evidence} ${styles.indent}`}>
      {attachedPhoto && (
        <EvidencePhoto photo={attachedPhoto} className={styles.thumb} alt={t('scheduler.panel.checklist.execution.photoAlt')} />
      )}
      <span className={styles.evidenceText}>
        {comment && <span className={styles.comment}>{comment}</span>}
        {board && <span className={styles.board}>{board}</span>}
        {(checkedByName || when) && (
          <span className={styles.by}>{[checkedByName, when].filter(Boolean).join(' · ')}</span>
        )}
      </span>
    </div>
  );
}
